export const JOB_FAMILY_OPTIONS = [
  { key: 'Marketing & C&C Data, Tech, & Capablities', value: 'marketing-data-technology' },
  { key: 'Marketing Innovation', value: 'marketing-innovation' },
  { key: 'Insights and Portfolio Management', value: 'insights-portfolio-management' },
  { key: 'Change Management & Comms', value: 'change-management-comms' },
  { key: 'Frontline Marketing', value: 'frontline-marketing' },
  { key: 'Marketing Strategy', value: 'marketing-strategy' },
  { key: 'IMX Creative', value: 'imx-creative' },
  { key: 'IMX Design', value: 'imx-design' },
  { key: 'IMX Epics', value: 'imx-epics' },
  { key: 'IMX Connections & Media', value: 'imx-connections-media' },
]
